import React, { useEffect } from 'react';
import { Layout, Typography, Space, Card, Steps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const { Content } = Layout;
const { Title, Text } = Typography;
const { Step } = Steps;

const VPNInstructionPage = ({ isTelegramAvailable }) => {
  const navigate = useNavigate();
  const { t } = useApp();

  // Настраиваем кнопки Telegram
  useEffect(() => {
    if (isTelegramAvailable && window.Telegram?.WebApp) {
      try {
        const backButton = window.Telegram.WebApp.BackButton;
        const mainButton = window.Telegram.WebApp.MainButton;

        // Показываем BackButton
        if (backButton) {
          backButton.show();
          const handleBackClick = () => {
            navigate('/');
          };
          backButton.onClick(handleBackClick);

          // Скрываем MainButton
          if (mainButton) {
            mainButton.hide();
          }

          return () => {
            backButton.offClick(handleBackClick);
            backButton.hide();
          };
        }
      } catch (error) {
        console.warn('Ошибка при настройке кнопок Telegram:', error);
      }
    }
  }, [navigate, isTelegramAvailable]);

  const vpnSteps = [
    {
      title: t('instruction_step1_title'),
      description: t('instruction_step1_desc')
    },
    {
      title: t('instruction_step2_title'),
      description: t('instruction_step2_desc')
    },
    {
      title: t('instruction_step3_title'),
      description: t('instruction_step3_desc')
    },
    {
      title: t('instruction_step4_title'),
      description: t('instruction_step4_desc')
    },
    {
      title: t('instruction_step5_title'),
      description: t('instruction_step5_desc')
    },
    {
      title: t('instruction_step6_title'),
      description: t('instruction_step6_desc')
    }
  ];

  const homeScreenSteps = [
    {
      title: t('instruction_home_step1_title'),
      description: t('instruction_home_step1_desc')
    },
    {
      title: t('instruction_home_step2_title'),
      description: t('instruction_home_step2_desc')
    },
    {
      title: t('instruction_home_step3_title'),
      description: t('instruction_home_step3_desc')
    }
  ];

  return (
    <Layout>
      <Content style={{ padding: '16px' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          {/* Основная инструкция */}
          <Card>
            <Title level={4} style={{ marginBottom: '16px', marginTop: '0px' }}>{t('instruction_vpn_title')}</Title>
            <Steps 
              direction="vertical" 
              size="small"
              progressDot
              current={vpnSteps.length}
            >
              {vpnSteps.map((step, index) => (
                <Step
                  key={index}
                  title={step.title}
                  description={step.description}
                />
              ))}
            </Steps>
          </Card>

          {/* Инструкция для добавления на домашний экран */}
          <Card>
            <Title level={4} style={{ marginBottom: '16px', marginTop: '0px' }}>
              {t('instruction_home_title')}
            </Title>
            <Steps 
              direction="vertical" 
              size="small"
              progressDot
              current={homeScreenSteps.length}
            >
              {homeScreenSteps.map((step, index) => (
                <Step
                  key={index}
                  title={step.title}
                  description={step.description}
                />
              ))}
            </Steps>
          </Card>

          {/* Дополнительная информация */}
          <Card>
            <Text type="secondary">
              {t('instruction_support')}
            </Text>
          </Card>

        </Space>
      </Content>
    </Layout>
  );
};

export default VPNInstructionPage;
